module.exports = __webpack_public_path__ + "static/ikg-e721804b4f831f7b8e204faeef86479b.png";